import { Breadcrumb, Button, Card, Col, Empty, message, Radio, Row, Select, Slider, Space, Spin, Tooltip, Typography } from 'antd';
import { Content } from 'antd/es/layout/layout';
import Title from 'antd/es/typography/Title';
import React, { useEffect, useReducer, useState } from 'react';
import Plot from 'react-plotly.js';
import { BookOutlined, HomeOutlined, SoundOutlined } from '@ant-design/icons';

import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context';
import axios from 'axios';
import vspSurveyReducer from './reducer';
import { FIELD_LITHOLOGY_INFO, FIELD_LITHOLOGY_INFO_ERROR, FIELD_LITHOLOGY_INFO_SUCCESS, PLOT_WELL_DATA_INFO, PLOT_WELL_DATA_INFO_ERROR, PLOT_WELL_DATA_INFO_SUCCESS, VSP_SURVEY_DETAILS, VSP_SURVEY_DETAILS_ERROR, VSP_SURVEY_DETAILS_SUCCESS, VSP_SURVEY_INFO, VSP_SURVEY_INFO_ERROR, VSP_SURVEY_INFO_SUCCESS } from './constants';

const VSPSurvey = () => {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;

	const { state } = useLocation();
	const navigate = useNavigate();
	const initalState = {vspSurveyData: [], fieldLithology_data: [], plotWellData:[], vspSurveyDetail_data: [], loading: false, error: false };
	const [vspSurveyReducerData, dispatch] = useReducer(vspSurveyReducer, initalState);
	const {wellFieldinfo, getWellFieldsInfo, wellinfo, getWellInfo, surveySeriesinfo, getSurveySeriesInfo} = useAuth();
	const [dtsEnabled, setdtsEnabled] = useState();
	const [dasEnabled, setdasEnabled] = useState();
	const [viewType, setViewType] = useState( dasEnabled == false && dtsEnabled == true ? 'DTS' : dasEnabled == true && dtsEnabled == true ?  'DAS' : dasEnabled == true && dtsEnabled == false ? 'DAS': 'DAS' );
	// const [dasSocket, setDasSocket] = useState();
	// const [dtsSocket, setDtsSocket] = useState();
	// const [spin, setSpin] = useState(false);

	const [wellFieldId, setwellFieldId] = useState(null);
	const [fieldOffset ,setFieldOffset] = useState(null);
	const [vspSurveys, setVSPSurveys] = useState([]);
	const [vspSurveyId, setVSPSurveyId] = useState(null);


	const [maxDistance, setmaxDistance] = useState(null);
	const [minDistance ,setminDistance] = useState(null);
	const [maxDepth, setmaxDepth] = useState(null);
	const [minDepth, setminDepth] = useState(null);
	const [suveyseriesId, setSurveySeriesId] = useState(null);

	const [wellInfoLoaded, setWellInfoLoaded] = useState(false);


	let tempWellFieldId;
	let tempmaxDistance;
	let tempminDistance;
	let tempmaxDepth;
	let tempminDepth;
	let dtsEnabled1 =true;
	let dasEnabled1 =true;
	let wellinfoOffset = 0;
	let tempsuveyseriesId;

	let plotwellIds = [];
	let welldetailsData = [];

	if (wellinfo && wellinfo.length > 0) {
		wellinfo.forEach((item) => {
			plotwellIds.push(item.id);

			welldetailsData.push({
				id: item.id,
				name: item.name,
				startDepth: item.startDepth,
				endDepth: item.endDepth,
				offsetDistance: item.offsetDistance
			});
		});
	} else {
		plotwellIds = [];
		welldetailsData = [];
	}
	
	useEffect(() => {
		getWellFieldsInfo(authtoken);
		getSurveySeriesInfo(authtoken, null);
	},[authtoken]);
	
	const wellFields = [];
	wellFieldinfo && wellFieldinfo.map((item, index) => {
		wellFields.push({
			value : item.id,
			label : item.name.toUpperCase(),
			distanceFrom: item.distanceFrom,
			distanceTo: item.distanceTo,
			depthFrom: item.depthFrom,
			depthTo: item.depthTo

		});
		if(index == 0){
			tempWellFieldId = item.id;
			tempminDistance = parseInt(item.distanceFrom);
			tempmaxDistance = parseInt(item.distanceTo + wellinfoOffset);
			tempminDepth = parseInt(item.depthFrom);
			tempmaxDepth = parseInt(item.depthTo);
		}
	});

	const suveySeriesData = [];
	surveySeriesinfo && surveySeriesinfo.map((item, index) => {
		suveySeriesData.push({
			value : item.id,
			label : item.name.toUpperCase()
		});
		if(index==0){
			tempsuveyseriesId = item.id;
		}
		
	});

	const vspSurveyOffsets = [];
	const vspSurveyOffsetsobjects = {};
	const seenOffsets = new Set();

	const sortedSurveyData = vspSurveyReducerData?.vspSurveyData
		?.slice()
		.sort((a, b) => a.offsetDistance - b.offsetDistance);

	const maxvalue = sortedSurveyData && sortedSurveyData.length > 0
		? sortedSurveyData[sortedSurveyData.length - 1].offsetDistance
		: 0;

	const minvalue = sortedSurveyData?.length
		? sortedSurveyData.at(0).offsetDistance
		: 0;

	sortedSurveyData?.forEach((item) => {
		const offset = item.offsetDistance;

		if (
			offset !== '' &&
		!isNaN(offset) &&
		!seenOffsets.has(offset)
		) {
			seenOffsets.add(offset);

			vspSurveyOffsets.push({
				value: offset,
				label: offset,
			});

			if (offset === fieldOffset) {
				vspSurveyOffsetsobjects[offset] = {
					style: { color: '#f50' },
					label: <strong>{offset + 'm'}</strong>,
				};
			} else {
				vspSurveyOffsetsobjects[offset] = `${offset} m`;
			}
		}
	});	
	

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());


	useEffect(() => {
		setdtsEnabled(dtsEnabled1);
		setdasEnabled(dasEnabled1);
	},[dtsEnabled1, dasEnabled1]);
	
	useEffect(() => {
		loadFieldLithology(wellFieldId ? wellFieldId : tempWellFieldId);
		getWellInfo(authtoken, wellFieldId ? wellFieldId : tempWellFieldId);
		setWellInfoLoaded(true);
	},[tempWellFieldId, wellFieldId]);

	useEffect(() => {

		if (wellInfoLoaded && wellinfo?.length > 0) {
			loadWellPlotData();
			setWellInfoLoaded(false);
		}
	}, [wellInfoLoaded, wellinfo]);

	useEffect(() => {
		loadVSPOffsets(wellFieldId ? wellFieldId : tempWellFieldId);
	},[tempWellFieldId, wellFieldId, suveyseriesId, tempsuveyseriesId]);

	const loadWellPlotData = () =>{		
	
		if(plotwellIds && plotwellIds.length > 0){
	
			dispatch({ type : PLOT_WELL_DATA_INFO });
			let config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: `${api}/crosswellcooridnatesdata?wellIds=${JSON.stringify(plotwellIds)}`,
				timeout: timeout,
				headers: { 
					Authorization:`Bearer ${authtoken}`
				}
			};
					
			axios.request(config)
				.then((response) => {
					if(response.status == 200) {												
						dispatch({ type : PLOT_WELL_DATA_INFO_SUCCESS, payload : response });
					} 
					else {
						dispatch({ type : PLOT_WELL_DATA_INFO_ERROR });
					}
				})
				.catch((error) => {
					console.log(error);
					dispatch({ type : PLOT_WELL_DATA_INFO_ERROR });
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}else{
			let response ={data:[]};
			dispatch({ type : PLOT_WELL_DATA_INFO_SUCCESS, payload : response });
		}
	};

	const handleDetail = () => {
		navigate(( '/vsp-survey-details'),{ state: { data: {wellFieldId:wellFieldId ? wellFieldId : tempWellFieldId}, path: 'vsp-survey' } });
	};

	const handleSetWellField = (e, options) =>{

		plotwellIds =[];
		let response ={data:[]};
		dispatch({ type : PLOT_WELL_DATA_INFO_SUCCESS, payload : response });
		getWellInfo(authtoken, e);
		loadWellPlotData();


		setFieldOffset(null);
		setwellFieldId(e);
		// loadVSPOffsets(e);
		setVSPSurveys([]);
		setVSPSurveyId(null);
		setSurveySeriesId(null);
		setminDistance(parseInt(options.distanceFrom));
		setmaxDistance(parseInt(options.distanceTo + wellinfoOffset));
		setminDepth(parseInt(options.depthFrom));
		setmaxDepth(parseInt(options.depthTo));
		// loadFieldLithology(e);
	};

	const handleSetSurveySeries = (e) =>{

		setFieldOffset(null);
		// loadVSPOffsets(e);
		setVSPSurveys([]);
		setVSPSurveyId(null);
	
		setSurveySeriesId(e);
		// loadFieldLithology(e);
	};


	const loadVSPOffsets = (fieldId) =>{

		if(fieldId){

			let params = '';
			if (suveyseriesId || tempsuveyseriesId){
				params += `&seriesId=${suveyseriesId ? suveyseriesId : tempsuveyseriesId}`;
			}
		
			dispatch({ type : VSP_SURVEY_INFO });
			let config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: `${api}/vspsurvey?wellFieldId=${fieldId}${params}&$sort[id]=1`,
				timeout: timeout,
				headers: { 
					Authorization:`Bearer ${authtoken}`
				}
			};
						
			axios.request(config)
				.then((response) => {
					if(response.status == 200) {
						dispatch({ type : VSP_SURVEY_INFO_SUCCESS, payload : response.data });
					} 
					else {
						dispatch({ type : VSP_SURVEY_INFO_ERROR });
					}
				})
				.catch((error) => {
					console.log(error);
					dispatch({ type : VSP_SURVEY_INFO_ERROR });
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}

	};

	const loadFieldLithology = (wellFieldid)=>{
		if(wellFieldid){
		
			dispatch({ type : FIELD_LITHOLOGY_INFO });
			let config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: `${api}/fieldlithology?wellFieldId=${wellFieldid}&$sort[id]=1`,
				timeout: timeout,
				headers: { 
					Authorization:`Bearer ${authtoken}`
				}
			};
						
			axios.request(config)
				.then((response) => {
					if(response.status == 200) {
						dispatch({ type : FIELD_LITHOLOGY_INFO_SUCCESS, payload : response.data });
					} 
					else {
						dispatch({ type : FIELD_LITHOLOGY_INFO_ERROR });
					}
				})
				.catch((error) => {
					console.log(error);
					dispatch({ type : FIELD_LITHOLOGY_INFO_ERROR });
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}
	};

	const handleSetFieldOffset = (offset) =>{		

		setVSPSurveyId(null);
		setFieldOffset(offset);
		loadVSPSurveys(offset);

	};
	
	
	const loadVSPSurveys = (offset) =>{

		const vspSurveys = [];
		let firstMatchedData = {data: []};


		vspSurveyReducerData && vspSurveyReducerData?.vspSurveyData?.map((item) => {
			
			if (item.offsetDistance == offset){
				if ( Array.isArray(firstMatchedData.data) && firstMatchedData.data.length === 0 && item.velocity != null ) {
					
					firstMatchedData['data'] = [item];
					setVSPSurveyId(item.id);
					setSurveySeriesId(item.seriesId);
				}
				
				vspSurveys.push({
					value : item.id,
					label : item.name
				});
			}

			dispatch({ type : VSP_SURVEY_DETAILS_SUCCESS, payload : firstMatchedData });
			
		});		

		setVSPSurveys(vspSurveys);

	};

	const handleSetVSPSurveyId = (e) =>{
		
		setVSPSurveyId(e);
		getEachVSPSurveyData(e);

	};

	const getEachVSPSurveyData = (id) =>{

		if(id){
		
			dispatch({ type : VSP_SURVEY_DETAILS });
			let config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: `${api}/vspsurvey?id=${id}&$sort[id]=1`,
				timeout: timeout,
				headers: { 
					Authorization:`Bearer ${authtoken}`
				}
			};
						
			axios.request(config)
				.then((response) => {
					if(response.status == 200) {
						dispatch({ type : VSP_SURVEY_DETAILS_SUCCESS, payload : response.data });
					} 
					else {
						dispatch({ type : VSP_SURVEY_DETAILS_ERROR });
					}
				})
				.catch((error) => {
					console.log(error);
					dispatch({ type : VSP_SURVEY_DETAILS_ERROR });
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}

	};


	const layers = [];

	vspSurveyReducerData?.fieldLithology_data?.data?.forEach(item => {
		const layersArr = item.lithologyData?.layers || [];
		const depthsArr = item.lithologyData?.depths || [];
		const colorsArr = item.lithologyData?.colors || [];
		const velocitiesArr = item.lithologyData?.velocities || [];
		const densitiesArr = item.lithologyData?.densities || [];

		layersArr.forEach((layerName, i) => {
			if (typeof depthsArr[i + 1] !== 'undefined' && layerName) {
				layers.push({
					name: layerName,
					depthfrom: Number(depthsArr[i]),
					depthto: Number(depthsArr[i + 1]),
					color: colorsArr[i],
					velocity: velocitiesArr[i],
					density: densitiesArr[i],
				});
			}
		});
	});

	const shapes = layers.map((layer) => ({
		type: 'rect',
		x0: minvalue || minvalue == 0 ? minvalue - 50 : tempminDistance -50,
		x1: maxDistance || maxDistance == 0 ? maxDistance + 50 : tempmaxDistance + 50,
		y0: layer.depthfrom,
		y1: layer.depthto,
		fillcolor: layer.color,
		line: { width: 1 },
		layer:'below'
	}));

	// const shapes =[];

	const annotations = layers.map((layer) => ({
		x: maxDistance || maxDistance == 0 ? parseInt((minvalue + maxDistance)/2) : parseInt((minvalue+tempmaxDistance)/2),
		y: (Number(layer.depthfrom) + Number(layer.depthto)) / 2,
		text: layer.name,
		showarrow: false,
		font: {
			color: 'white',
			size: 12,
		},
		layer:'below'
	}));

	const hoverTraces = layers.map((layer) => ({
		x: maxDistance || maxDistance == 0 ? [(minvalue + maxDistance)/2] : [(minvalue+tempmaxDistance)/2],
		y: [(layer.depthfrom + layer.depthto) / 2],
		type: 'scatter',
		mode: 'markers',
		marker: {
			size: 20,
			opacity: .5,
			color: layer.color,
		},
		// hoverinfo: 'text',
		hoverlabel: {
			bgcolor: layer.color,
			font: { color: 'white' },
		},
		name: `<br><b>${layer.name}</b><br><br>Depth: ${layer.depthfrom}–${layer.depthto} m<br>Velocity: ${layer.velocity ?? 'N/A'} m/s<br>Density: ${layer.density ?? 'N/A'} g/cc`,
		hovertemplate: `<b>${layer.name}</b><br>Depth: ${layer.depthfrom}–${layer.depthto} m<br>Velocity: ${layer.velocity ?? 'N/A'} m/s<br>Density: ${layer.density ?? 'N/A'} g/cc<extra></extra>`,
		showlegend: true,

	}));	

	// const hoverTraces =[];

	const layout = {
		title: {
			text: langdata?.VSPSurvey || 'VSP Survey',
			font: { size: 20, weight: 'bold' },
		},
		shapes: shapes,
		annotations: annotations,
		xaxis: {
			title: langdata?.FieldDistancem || 'Field Distance (m)',
			range: minvalue || minvalue == 0 &&  maxDistance || maxDistance == 0 ?  [minvalue -50, maxDistance] : [tempminDistance, tempmaxDistance],
			showgrid: false,
			showline: true,
			zerolinewidth: 4,
			zerolinecolor: 'green',
			zeroline: false,
			// autorange: true
		},
		yaxis: {
			title: langdata?.Depthm || 'Depth (m)',
			autorange: 'reversed',
			range: maxDepth || maxDepth == 0 &&  minDepth || minDepth == 0 ?  [maxDepth, minDepth] : [tempmaxDepth, tempminDepth],
			showgrid: false,
			
		},
		showlegend: true,
		images: [],
		margin: { t: 40, r: 40, l: 60, b: 60 },

		// sliders: [
		// 	{
		// 		active: 0,
		// 		yanchor: 'top',
		// 		y: 1.1,
		// 		steps: vspSurveyOffsetsarray.map((val) => ({
		// 			label: val.toString(),
		// 			method: 'restyle', // no actual change to data
		// 			args: [{}], // no-op
		// 		})),
		// 		currentvalue: {
		// 			visible: true,
		// 			prefix: 'Selected: ',
		// 			font: { size: 14 },
		// 		},
		// 	},
		// ],
	};	
		
	if(fieldOffset){	

		vspSurveyReducerData?.vspSurveyDetail_data?.forEach(item => {			
			
			const depthsArr = item.velocity?.depths || [];
			const offArr = item.velocity?.offsets || [];
			const velocitiesArr = item.velocity?.velocities || [];

			depthsArr.forEach((depths, i) => {

				welldetailsData && welldetailsData.map((wellitem)=>{

					if(wellitem.id == item.wellinfoId){

						wellinfoOffset = wellitem.offsetDistance;

						shapes.push({
	
							type: 'line',
							x0: fieldOffset + wellitem.offsetDistance,
							x1: fieldOffset + wellitem.offsetDistance,
							y0: minDepth || minDepth == 0 ? minDepth : tempminDepth,
							y1: maxDepth || maxDepth == 0 ? maxDepth : tempmaxDepth,
							xref: 'x',
							yref: 'y',
							line: {
								color: 'green', 
								width: 4,
								dash: 'dashdot'
							},
							layer: 'above'

						});

						shapes.push({
	
							type: 'line',
							x0: wellitem.offsetDistance,
							x1: fieldOffset + wellitem.offsetDistance,
							y0: wellitem.endDepth || wellitem.endDepth == 0 ? wellitem.endDepth/2 : tempmaxDepth/2,
							y1: wellitem.endDepth || wellitem.endDepth == 0 ? wellitem.endDepth/2 : tempmaxDepth/2,
							xref: 'x',
							yref: 'y',
							line: {
								color: 'green', 
								width: 4,
								dash: 'dashdot'
							},
							layer: 'above'

						});

						layout.annotations.push({
							x: ((fieldOffset+wellitem.offsetDistance)+wellitem.offsetDistance)/2,
							y: wellitem.endDepth || wellitem.endDepth == 0 ? wellitem.endDepth/2 : tempmaxDepth/2,
							xref: 'x',
							yref: 'y',
							text: langdata && langdata.Offsetfromthewell ? langdata.Offsetfromthewell + ' ' + fieldOffset + ' m' : 'Offset from the well' + ' ' + fieldOffset + ' m',
							showarrow: false,
							font: {
								size: 12,
								color: 'green',
							},
							bgcolor: '#d9d4d4bf',
							textangle: 0,
							xanchor: 'center',
							yanchor: 'bottom'
						});

						layout.shapes.push({
							type: 'line',
							x0: fieldOffset + wellitem.offsetDistance,
							x1: offArr[i],
							y0: minDepth || minDepth == 0 ? minDepth : tempminDepth,
							y1: depths,
							xref: 'x',
							yref: 'y',
							line: {
								color: 'blue', 
								width: 2,
								dash: 'dashdot'
							},
							layer: 'above'
						});

						layout.annotations.push({
							x: (fieldOffset + wellitem.offsetDistance + offArr[i]) / 2,
							y: ( depths ) / 2,
							xref: 'x',
							yref: 'y',
							text: `${velocitiesArr[i] + 'm/s'}`,
							showarrow: false,
							font: {
								size: 12,
								color: 'blue',
							},
							bgcolor: '#d9d4d4bf',
							textangle: 0,
							xanchor: 'center',
							yanchor: 'bottom'
						});

					}


				});

			});
		});

	}


	const imageTrace = {
		x: [fieldOffset + wellinfoOffset],
		y: [0],
		mode: 'text',
		text: ['🚛'],
		textfont: {
			size: 50
		},
		textposition: 'top center',
		showlegend: false,
		hoverinfo: 'text',
		hovertemplate: `<b>${langdata && langdata.OffsetDistance ? langdata.OffsetDistance : 'Offset Distance (m)'}: ${fieldOffset}<br><b>${langdata && langdata.FieldDistancem ? langdata.FieldDistancem : 'Field Distance (m)'}: ${fieldOffset + wellinfoOffset}<extra></extra>`,
		hoverlabel: {
			bgcolor: 'red',
			font: { color: 'white' },
		},
	};
	
	hoverTraces.push(imageTrace);

	if (wellFieldId || tempWellFieldId){
		
		vspSurveyReducerData && vspSurveyReducerData.plotWellData.map((item)=>{
			hoverTraces.push({
				x: item.x,
				y: item.z,
				// z: item.z,
				type: 'scatter',
				mode: 'lines',
				line: {
					color: '#bcc50cf6',
					width: 9,
					dash: 'solid',
					shape: 'spline',
					cap: 'round',
					opacity : .5
				},
				// marker: { size: 2, color: isParent ? 'blue' : 'black' },
				showlegend: false,
				hoverinfo: 'text',
				// name: `<b>${langdata?.WellName ?? 'Well Name'}<b>: ${item.wellName}<br>${langdata?.WellType ?? 'Well Type'}: ${isParent ? (langdata?.Productionwell ?? 'Production well') : (langdata?.Monitoringwell ?? 'Monitoring well')}`,
				hovertemplate: `<b>${langdata?.WellName ?? 'Well Name'}<b>: ${item.wellName}<br><extra></extra>`
			});

			layout.annotations.push({
				x: item.x.at(0),
				y: minDepth || minDepth == 0 ? minDepth : tempminDepth,
				xref: 'x',
				yref: 'y',
				text: `${item.wellName}`,
				showarrow: false,
				font: {
					size: 12,
					color: 'red',
				},
				bgcolor: '#d9d4d4bf',
				textangle: 0,
				xanchor: 'center',
				yanchor: 'bottom'
			});
			
		});

	}	
	
	
	return (

		<Content>
			<Row style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center'
			}} >
		
				<Col span={8}>
					<Row>
						<Space>
							<SoundOutlined style={{fontSize:'30px'}}/>
							{/* </Col> */}
						</Space>
						<Space>&nbsp;&nbsp;</Space>
							
						{/* <Col style={{marginLeft:'4px'}} span={19}> */}
						<Title level={4} style={{ paddingTop:'10px'}}> {langdata && langdata.VSPSurvey ? langdata.VSPSurvey : 'VSP Survey'}</Title>
						<Space>&nbsp;&nbsp;</Space>
						{dasEnabled == true && dtsEnabled == true ?
							<Space>
								<Radio.Group style={{margin:'5px'}} value={viewType} onChange={(e) => setViewType(e.target.value)}>
									{/* <Radio.Button value="DAS">{langdata && langdata.DAS ? langdata.DAS : 'DAS'}</Radio.Button>
									<Radio.Button value="DTS">{langdata && langdata.DTS ? langdata.DTS : 'DTS'}</Radio.Button> */}
								</Radio.Group>
							</Space>
							: null }
					</Row>
				</Col>
				<Col span={16}>
					<Row justify="end">
						<Col>
							<Tooltip placement="bottom" title={langdata && langdata.Pleaseselectthewellfield ? langdata.Pleaseselectthewellfield : 'Please select the well field'}>
								<Space>
									<Select
										style={{ width: '180px', margin:'5px'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.Pleaseselectthewellfield ? langdata.Pleaseselectthewellfield : 'Please select the well field'}
										optionFilterProp="children"
										value={wellFieldId ? wellFieldId : tempWellFieldId}
										options={wellFields}
										onSelect={(e, options)=>handleSetWellField(e, options)}
									/>
								</Space>
							</Tooltip>
							<Space>&nbsp;</Space>

							<Tooltip placement="bottom" title={langdata && langdata.Pleaseselectthesurveyseries ? langdata.Pleaseselectthesurveyseries : 'Please select the survey series'}>
								<Space>
									<Select
										style={{ width: '180px', margin:'5px'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.Pleaseselectthesurveyseries ? langdata.Pleaseselectthesurveyseries : 'Please select the survey series'}
										optionFilterProp="children"
										value={suveyseriesId ? suveyseriesId : tempsuveyseriesId}
										options={suveySeriesData}
										onSelect={(e, options)=>handleSetSurveySeries(e, options)}
									/>
								</Space>
							</Tooltip>
							<Space>&nbsp;</Space>

							<Tooltip placement="bottom" title={(!wellFieldId && ! tempWellFieldId)? langdata && langdata.Pleaseselectthewellfield ? langdata.Pleaseselectthewellfield : 'Please select the well field' : langdata && langdata.OffsetDistance ? langdata.OffsetDistance : 'Offset Distance'}>
								<Space>

									<Select
										style={{ width: '180px', margin:'5px'}}
										showSearch
										disabled={(!wellFieldId && ! tempWellFieldId)}
										filterOption={filterOption}
										placeholder={langdata && langdata.OffsetDistance ? langdata.OffsetDistance : 'Offset Distance (m)'}
										optionFilterProp="children"
										value={fieldOffset}
										options={vspSurveyOffsets}
										onSelect={(e)=>handleSetFieldOffset(e)}
									/>
								</Space>
							</Tooltip>
							<Space>&nbsp;</Space>
							<Tooltip placement="bottom" title={fieldOffset || fieldOffset == 0 ? langdata && langdata.VSPSurvey ? langdata.VSPSurvey : 'VSP Survey' : langdata && langdata.Pleaseentertheoffsetdistance ? langdata.Pleaseentertheoffsetdistance : 'Please enter the offset distance'}>
								<Space>

									<Select
										style={{ width: '180px', margin:'5px'}}
										showSearch
										disabled={fieldOffset || fieldOffset == 0 ? false : true}
										filterOption={filterOption}
										placeholder={langdata && langdata.VSPSurvey ? langdata.VSPSurvey : 'VSP Survey'}
										optionFilterProp="children"
										value={vspSurveyId}
										options={vspSurveys}
										onSelect={(e, options)=>handleSetVSPSurveyId(e, options)}
									/>
								</Space>
							</Tooltip>
							<Space>&nbsp;</Space>
							<Tooltip placement="bottom" title={langdata && langdata.AddVSPSurvey ? langdata.AddVSPSurvey:'Add VSP Survey'}>
								<Button
									style={{ margin:'5px'}}
									type='primary'
									onClick={handleDetail}
								>{langdata && langdata.VSPSurvey ? langdata.VSPSurvey:'VSP Survey'}</Button>
							</Tooltip>

						</Col>
					</Row>
				</Col>
			</Row>
			<Row style={{
				margin: '10px',
				// marginTop : '5px',
				// paddingLeft: '10px',
				// paddingRight: '10px',
				// background: '#FFFFFF',
				alignItems:'center',
			}}  >
				<Col span={18}>
					<Breadcrumb
						items={[
							{
								href: '/dashboard',
								title: <HomeOutlined />,
							},
							{
								title: <a onClick={()=>{navigate('/well-visualization');}}>{langdata && langdata.WellVisualization ? langdata.WellVisualization:'Well Visualization'}</a>
							},
							{
								title: (state && state.path && state.path == 'vsp-survey' ? <a onClick={()=>{navigate('/vsp-survey');}}>{state && state.pathName}</a> : null)
							},
							{
								title: `${langdata && langdata.VSPSurvey ? langdata.VSPSurvey : 'VSP Survey'}`,
							},
						]}
						// style={{ marginBottom : '10px'}}
					/>
				</Col>
				<Col span={6} style={{ display : 'flex', justifyContent : 'flex-end'}}>
					{/* <Tooltip title={langdata && langdata.Graphlayout ? langdata.Graphlayout:'Graph layout'}>
						<Switch style={{backgroundColor: graphScroll == false ? '' : 'green'}} checkedChildren={langdata && langdata.Scroll ? langdata.Scroll:'Scroll'} unCheckedChildren={langdata && langdata.Fixed ? langdata.Fixed:'Fixed'} checked={graphScroll} onClick={handleSelectGraphScroll}/>
					</Tooltip> */}
				</Col>
			</Row>
			{viewType == 'DAS' ? 
				<Card style={{ minHeight: '500px', padding : '5px', marginLeft : '20px', marginRight : '20px'  }}>
					<Row style={{
					// margin: '10px',
					// marginBottom : '0px',
					// marginTop : '10px',
					// paddingLeft: '10px',
					// paddingRight: '10px',
					// backgroundColor: '#ffffff',
						alignItems:'center',
					}} >
						<Col span={24}>	
							<Col span={24}>
								<h4>{langdata && langdata.Offsetfromthewell ? langdata.Offsetfromthewell: 'Offset from the well'}</h4>
								<Slider marks={vspSurveyOffsetsobjects} step={null} max={maxvalue} min={minvalue && minvalue < maxvalue ? minvalue : minDistance}
									onChange={(e)=>handleSetFieldOffset(e)} value={fieldOffset ? fieldOffset : 0}
								/>
							</Col>
							<Col>
								{/* <Spin spinning={spin} tip={`${langdata && langdata.Loading ? langdata.Loading: 'Loading'}...`} > */}
								{wellFieldId || tempWellFieldId?
									<>
										<Plot
											data={hoverTraces}
											layout={layout}

											style={{ width: '100%', height: '800px' }}
											config={{
												responsive: true,
												displayModeBar: true,
												displaylogo : false,
												modeBarButtonsToRemove: [],
											}}

											// onUpdate={(figure) => {
											// 	if (
											// 		figure.layout &&
											// 		figure.layout.sliders &&
											// 		figure.layout.sliders[0] &&
											// 		typeof figure.layout.sliders[0].active === 'number'
											// 	) {
											// 		const newOffset = vspSurveyOffsetsarray[figure.layout.sliders[0].active];
											// 		if (newOffset !== fieldOffset) {
											// 			handleSetFieldOffset(newOffset); // <-- triggers dropdown logic too
											// 		}
											// 	}
											// }}
										/>
									</>
									: 
									<Empty 
										style={{marginTop:'100px'}}
										description={
											<Typography.Text>
												{langdata && langdata.Pleasechoosea ? langdata.Pleasechoosea:'Please choose a'} <span style={{color:'#1677FF'}}>{langdata && langdata.WellField ? langdata.WellField : 'Well Field'}</span>
											</Typography.Text>
										}
										image={<BookOutlined style={{fontSize :'70px', color:'#bab9b969', marginTop:'20px'}}/>} /> }
								{/* </Spin> */}
							</Col>
							{/* </Spin> */}
						</Col>
					</Row>
				</Card> :
				viewType == 'DTS' ?
					<Card style={{ minHeight: '500px', padding : '5px', marginLeft : '20px', marginRight : '20px'}}>
						<Row style={{
							// margin: '10px',
							// marginBottom : '0px',
							// marginTop : '10px',
							// paddingLeft: '10px',
							// paddingRight: '10px',
							// backgroundColor: '#ffffff',
							alignItems:'center',
						}} >
							<Col span={24}>				
								<Col >
									{/* <Spin spinning={spin} tip={`${langdata && langdata.Loading ? langdata.Loading: 'Loading'}...`} > */}
									<Plot
										data={[]}
										layout={layout}
										// style={{ width: '100%', height: '100%' }}
										style={{ width: '100%', height: '800px' }}
										config={{
											responsive: true,
											displayModeBar: true,
											displaylogo : false,
											modeBarButtonsToRemove: [],
			
										}}
									/>
									{/* </Spin> */}
								</Col>
								{/* </Spin> */}
							</Col>
						</Row>
					</Card> : null 

			}
	
			<Spin fullscreen spinning={vspSurveyReducerData.loading} />
		</Content>
		
	);
};

export default VSPSurvey;
